import { Button } from '@mui/material'
import { XSquare } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { ROUTES_PATH } from '@/constants'
import { useConfirmationModal } from '@/hooks/useConfirmationModal'
import { useDeleteQuotation, useMutationWrapper } from '@/hooks'

export type DeleteQuotationProps = {
  quotationId: number
}

export const DeleteQuotation = ({
  quotationId,
}: DeleteQuotationProps): JSX.Element => {
  const { t } = useTranslation('quotations')
  const { enqueueSnackbar } = useSnackbar()
  const { setConfirmationOpen } = useConfirmationModal()
  const { mutateAsync: deleteQuotation } = useMutationWrapper(() =>
    useDeleteQuotation({ quotationId: Number(quotationId) })
  )

  const handleDelete = () => {
    if (!quotationId) return

    setConfirmationOpen(
      t('titles.deleteConfirmation'),
      t('titles.deleteQuotation'),
      async () => {
        try {
          await deleteQuotation()

          enqueueSnackbar(t('common:buttons.confirmDelete'), {
            variant: 'success',
          })

          //navigate(ROUTES_PATH.QUOTATIONS, { replace: true })
          window.location.href = ROUTES_PATH.QUOTATIONS
        } catch (e) {
          enqueueSnackbar(`${t('errors:api.removeRequest')}: ${e}`, {
            variant: 'error',
          })
        }
      }
    )
  }

  return (
    <Button
      variant="text"
      color="error"
      onClick={handleDelete}
      endIcon={<XSquare size={16} />}
    >
      {t('buttons.deleteQuotation')}
    </Button>
  )
}
